const sections = document.querySelectorAll("section.cta");

if (sections.length) {
    sections.forEach(element => {
        const buttonB2b = element.querySelector(".cta__button-b2b");
        const sidebarSection = element.nextElementSibling;
        if (sidebarSection.classList.contains("cta-b2b")) {
            const sidebar = sidebarSection.querySelector(".cta-b2b__sidebar-wrapper");
            const closeElements = sidebarSection.querySelectorAll(".js-close-sidebar");
            if (buttonB2b) {
                buttonB2b.addEventListener("click", () => {
                    sidebar.classList.add("-active");
                })
            }
            if (closeElements.length) {
                closeElements.forEach(closeElement => {
                    closeElement.addEventListener("click", () => {
                        sidebar.classList.remove("-active");
                    })
                });
            }
        }
    });
}